// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
    {
        id: 1,
        title: 'Solat Now',
        category: 'Web Application',
        img: require('@/assets/images/web-project1.png'),
        description: 'A modern web application providing accurate Islamic prayer times using JAKIM API.',
        tags: ['React', 'Neon', 'SQL', 'Tailwind'],
        link: 'https://ramadan-tracker-beta.vercel.app',
    },
    {
        id: 2,
        title: 'Airworthiness Blog using Filament PHP',
        category: 'Web Application',
        img: require('@/assets/images/web-project1.png'),
        description: 'A modern blog built with Laravel and Filament PHP, featuring a comprehensive admin dashboard for content management and a clean frontend for readers.',
        tags: ['Filament', 'Laravel', 'MySql', 'Deployment'],
        link: 'https://airworthinessforum.com/',
    },
    {
        id: 3,
        title: 'Job Portal Web Application',
        category: 'Web Application',
        img: require('@/assets/images/web-project2.png'),
        description: 'A job portal built with Laravel. Features include creating and managing job postings, alongside a commenting system for user discussions.',
        tags: ['Laravel', 'Tailwind Css', 'PostgreSQL'],
        link: 'https://github.com/dinsuprano/cms-project',
    },
    {
        id: 4,
        title: 'Blog Management System',
        category: 'Web Application',
        img: require('@/assets/images/web-project2.png'),
        description: 'A simple blog system built with Laravel and Livewire 3, offering full CRUD functionality for posts and an interactive commenting feature.',
        tags: ['Laravel', 'Livewire 3', 'Bootstrap 5'],
        link: 'https://github.com/dinsuprano/Blog-using-Livewire-3',
    },
    {
        id: 5,
        title: 'Product Management System',
        category: 'Web Application',
        img: require('@/assets/images/web-project2.png'),
        description: 'A product management dashboard built with Filament, enabling efficient inventory tracking and streamlined administrative controls in real-time.',
        tags: ['TailwindCSS', 'PHP', 'Filament'],
        link: 'https://github.com/dinsuprano/filament-web-app',
    },
    {
        id: 6,
        title: 'Personal Blog Website',
        category: 'Web Application',
        img: require('@/assets/images/web-project2.png'),
        description: 'A modern, responsive personal blog template built with React and TailwindCSS for sharing articles and experiences.',
        tags: ['TailwindCSS', 'React',],
        link: 'https://aviation-simple-blog.vercel.app/',
    },
    {
        id: 7,
        title: 'Aircraft Tools Management',
        category: 'Web Application',
        img: require('@/assets/images/web-project1.png'),
        description: 'A web-based management system built with PHP and MySQL for efficient tracking, storage, and retrieval of aircraft tools.',
        tags: ['PHP', 'MySQL', 'Bootstrap 5'],
        link: 'https://github.com/dinsuprano/Aircraft-Tools-Management',
    },
    {
        id: 8,
        title: 'Wordpress Development',
        category: 'Web Application',
        img: require('@/assets/images/web-project1.png'),
        description: 'A fully customized WordPress website featuring tailored theme configuration, plugin integration, and comprehensive content management.',
        tags: ['Wordpress', 'Deployment', 'Elementor'],
        link: 'https://chambersofnadzrulniezar.com',
    },
    {
        id: 9,
        title: 'Blood Pressure Management System',
        category: 'Web Application',
        img: require('@/assets/images/web-project1.png'),
        description: 'A Next.js application for logging and managing blood pressure records, utilizing Prisma and PostgreSQL for reliable data storage.',
        tags: ['Next Js', 'Prisma', 'Vercel', 'PostgreSQL'],
        link: 'https://github.com/dinsuprano/blood-pressure-app',
    },

    // Add more projects as needed
];

export default projects;
